(ns hypnos.dme.tile.table.survey
  "The table containing survey answer ."
  (:require [clojure.string :as str]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- valid-weight?
  [_weight]
  true
  #_(s/valid? :hypnos.consumer.specs/weight weight))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn instructions
  "Show survey instructions."
  []
  [:article.message.is-success
   [:div.message-body (tr :ui.instruction/survey)]])

(defn answers
  "The survey answers."
  [state]
  [:div.table-container
   [:table.table.is-striped.is-fullwidth
    [:tbody
     [:tr
      [:th (tr :ui.label/weight)]
      [:td {:col-span 3}
       [:div.field.is-expanded
        [:div.field.has-addons
         [:p.control.is-fullwidth
          [:input.input.is-small
           {:type       :text
            :max-length 3
            :class      (when-not (or (nil? (get-in @state [:patient :patient/last-consult :consult/weight :valid?]))
                                      (get-in @state [:patient :patient/last-consult :consult/weight :valid?]))
                          "is-danger")
            :value      (if-let [val (get-in @state [:patient :patient/last-consult :consult/weight :value])]
                          val
                          "")
            :on-change  (fn [e]
                          (let [val       (-> e .-target .-value)
                                old-value (get-in @state [:patient :patient/last-consult :consult/weight :value])
                                new-value (when-not (str/blank? val) (int val))
                                changed?  (or (get-in @state [:patient :patient/last-consult :consult/weight :dirty?])
                                              (not= new-value old-value))]
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/weight :value]
                                   new-value)
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/weight :dirty?]
                                   changed?)
                            (when (valid-weight? new-value)
                              (swap! state assoc-in
                                     [:patient :patient/last-consult :consult/weight :valid?]
                                     true))))
            :on-focus   (fn [_]
                          (swap! state assoc-in
                                 [:patient :patient/last-consult :consult/weight :touched?]
                                 true))
            :on-blur    (fn [_]
                          (swap! state assoc-in
                                 [:patient :patient/last-consult :consult/weight :valid?]
                                 (valid-weight? (get-in @state [:patient :patient/last-consult :consult/weight :value]))))}]]
         [:p.control
          [:a.button.is-static.is-small (tr :ui.label/pounds)]]]
        (when-not (or (nil? (get-in @state [:patient :patient/last-consult :consult/weight :valid?]))
                      (get-in @state [:patient :patient/last-consult :consult/weight :valid?]))
          [:p.help.is-danger (tr :ui.validation/weight)])]]
      [:td {:col-span 2}]]
     ;; details
     [:tr                           ; first row
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-right
            {:data-tooltip (tr :ui.survey.eye-dryness/question)}
            (tr :ui.label/eye-dryness?)]]
      [:td
       (if-not (= :service-type/new-setup (get-in @state [:patient :patient/last-consult :consult/service-type :value]))
         [:div.field.is-grouped-multiline.is-grouped
          [:div.control
           [:label.b-radio.radio
            [:input.input {:type      :radio
                           :name      "eye-dryness"
                           :checked   (true? (get-in @state [:patient :patient/last-consult :consult/eye-dryness? :value]))
                           :on-change (fn [e]
                                        (let [old-value (get-in @state [:patient :patient/last-consult :consult/eye-dryness? :value])
                                              new-value (when (-> e .-target .-checked) true)
                                              changed?  (or (get-in @state [:patient :patient/last-consult :consult/eye-dryness? :dirty?])
                                                            (not= new-value old-value))]
                                          (swap! state assoc-in
                                                 [:patient :patient/last-consult :consult/eye-dryness? :value]
                                                 new-value)
                                          (swap! state assoc-in
                                                 [:patient :patient/last-consult :consult/eye-dryness? :dirty?]
                                                 changed?)))
                           :on-focus  (fn [_] (swap! state assoc-in
                                                     [:patient :patient/last-consult :consult/eye-dryness? :touched?]
                                                     true))}]
            [:span.check.is-info]
            [:span.control-label (tr :ui.label/yes)]]]
          [:div.control
           [:label.b-radio.radio
            [:input.input {:type      :radio
                           :name      "eye-dryness"
                           :checked   (false? (get-in @state [:patient :patient/last-consult :consult/eye-dryness? :value]))
                           :on-change (fn [e]
                                        (let [old-value (get-in @state [:patient :patient/last-consult :consult/eye-dryness? :value])
                                              new-value (when (-> e .-target .-checked) false)
                                              changed?  (or (get-in @state [:patient :patient/last-consult :consult/eye-dryness? :dirty?])
                                                            (not= new-value old-value))]
                                          (swap! state assoc-in
                                                 [:patient :patient/last-consult :consult/eye-dryness? :value]
                                                 new-value)
                                          (swap! state assoc-in
                                                 [:patient :patient/last-consult :consult/eye-dryness? :dirty?]
                                                 changed?)))
                           :on-focus  (fn [_] (swap! state assoc-in
                                                     [:patient :patient/last-consult :consult/eye-dryness? :touched?]
                                                     true))}]
            [:span.check.is-info]
            [:span.control-label (tr :ui.label/no)]]]]
         [:span (tr :ui.label/na)])]
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-bottom
            {:data-tooltip (tr :ui.survey.dentures/question)}
            (tr :ui.label/dentures?)]]
      [:td
       [:div.field.is-grouped-multiline.is-grouped
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "dentures"
                         :checked   (true? (get-in @state [:patient :patient/last-consult :consult/take-dentures-out? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/take-dentures-out? :value])
                                            new-value (when (-> e .-target .-checked) true)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/take-dentures-out? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/take-dentures-out? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/take-dentures-out? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/take-dentures-out? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/yes)]]]
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "dentures"
                         :checked   (false? (get-in @state [:patient :patient/last-consult :consult/take-dentures-out? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/take-dentures-out? :value])
                                            new-value (when (-> e .-target .-checked) false)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/take-dentures-out? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/take-dentures-out? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/take-dentures-out? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/take-dentures-out? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/no)]]]]]
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-left
            {:data-tooltip (tr :ui.survey.chronic-issues/question)}
            (tr :ui.label/chronic-issues?)]]
      [:td
       [:div.field.is-grouped-multiline.is-grouped
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "chronic-issues"
                         :checked   (true? (get-in @state [:patient :patient/last-consult :consult/chronic-issues? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/chronic-issues? :value])
                                            new-value (when (-> e .-target .-checked) true)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/chronic-issues? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/chronic-issues? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/chronic-issues? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/chronic-issues? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/yes)]]]
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "chronic-issues"
                         :checked   (false? (get-in @state [:patient :patient/last-consult :consult/chronic-issues? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/chronic-issues? :value])
                                            new-value (when (-> e .-target .-checked) false)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/chronic-issues? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/chronic-issues? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/chronic-issues? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/chronic-issues? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/no)]]]]]]
     [:tr                           ; second row
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-right
            {:data-tooltip (tr :ui.survey.claustrophobia/question)}
            (tr :ui.label/claustrophobia-level)]]
      [:td
       (if-not (= :service-type/new-setup (get-in @state [:patient :patient/last-consult :consult/service-type :value]))
         [:div.field
          [:div.control
           [:div.select.is-rounded.is-small
            [:select
             {:value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/claustrophobia-level :value])]
                           val
                           "unk")
              :on-change (fn [e]
                           (let [old-value (get-in @state [:patient :patient/last-consult :consult/claustrophobia-level :value])
                                 new-value (when-not (= "unk" (-> e .-target .-value)) (int (-> e .-target .-value)))
                                 changed?  (or (get-in @state [:patient :patient/last-consult :consult/claustrophobia-level :dirty?])
                                               (not= new-value old-value))]
                             (swap! state assoc-in [:patient :patient/last-consult :consult/claustrophobia-level :value] new-value)
                             (swap! state assoc-in [:patient :patient/last-consult :consult/claustrophobia-level :dirty?] changed?)))
              :on-focus  (fn [_]
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/claustrophobia-level :touched?]
                                  true))}
             [:option {:key "unk" :value "unk"}]
             [:option {:key -1 :value -1} (tr :ui/claustrophobia-level-short -1)]
             [:option {:key 0 :value 0} (tr :ui/claustrophobia-level-short 0)]
             [:option {:key 1 :value 1} (tr :ui/claustrophobia-level-short 1)]
             [:option {:key 2 :value 2} (tr :ui/claustrophobia-level-short 2)]]]]]
         [:span (tr :ui.label/na)])]
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-bottom
            {:data-tooltip (tr :ui.survey.mouth-breathing-level/question)}
            (tr :ui.label/mouth-breathing-level)]]
      [:td
       [:div.field
        [:div.control
         [:div.select.is-rounded.is-small
          [:select
           {:value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/mouth-breathing-level :value])]
                         val
                         "unk")
            :on-change (fn [e]
                         (let [old-value (get-in @state [:patient :patient/last-consult :consult/mouth-breathing-level :value])
                               new-value (when-not (= "unk" (-> e .-target .-value)) (int (-> e .-target .-value)))
                               changed?  (or (get-in @state [:patient :patient/last-consult :consult/mouth-breathing-level :dirty?])
                                             (not= new-value old-value))]
                           (swap! state assoc-in [:patient :patient/last-consult :consult/mouth-breathing-level :value] new-value)
                           (swap! state assoc-in [:patient :patient/last-consult :consult/mouth-breathing-level :dirty?] changed?)))
            :on-focus  (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/mouth-breathing-level :touched?]
                                true))}
           [:option {:key "unk" :value "unk"}]
           [:option {:key 0 :value 0} (tr :ui/mouth-breathing-level-short 0)]
           [:option {:key 1 :value 1} (tr :ui/mouth-breathing-level-short 1)]
           [:option {:key 2 :value 2} (tr :ui/mouth-breathing-level-short 2)]
           [:option {:key 3 :value 3} (tr :ui/mouth-breathing-level-short 3)]]]]]]
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-left
            {:data-tooltip (tr :ui.survey.deviated-septum/question)}
            (tr :ui.label/deviated-septum?)]]
      [:td
       [:div.field.is-grouped-multiline.is-grouped
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "deviated-septum"
                         :checked   (true? (get-in @state [:patient :patient/last-consult :consult/deviated-septum? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/deviated-septum? :value])
                                            new-value (when (-> e .-target .-checked) true)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/deviated-septum? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/deviated-septum? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/deviated-septum? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/deviated-septum? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/yes)]]]
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "deviated-septum"
                         :value     (false? (get-in @state [:patient :patient/last-consult :consult/deviated-septum? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/deviated-septum? :value])
                                            new-value (when (-> e .-target .-checked) false)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/deviated-septum? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/deviated-septum? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/deviated-septum? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/deviated-septum? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/no)]]]]]]
     [:tr                           ; third row
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-right
            {:data-tooltip (tr :ui.survey.sleep-motion/question)}
            (tr :ui.label/sleep-motion)]]
      [:td
       [:div.field.is-grouped-multiline.is-grouped
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "sleep-motion"
                         :checked   (true? (get-in @state [:patient :patient/last-consult :consult/sleep-motion? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/sleep-motion? :value])
                                            new-value (when (-> e .-target .-checked) true)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/sleep-motion? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/sleep-motion? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/sleep-motion? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/sleep-motion? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/yes)]]]
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "sleep-motion"
                         :value     (false? (get-in @state [:patient :patient/last-consult :consult/sleep-motion? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/sleep-motion? :value])
                                            new-value (when (-> e .-target .-checked) false)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/sleep-motion? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/sleep-motion? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/sleep-motion? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/sleep-motion? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/no)]]]]]
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-bottom
            {:data-tooltip (tr :ui.survey.sleep-positions/question)}
            (tr :ui.label/sleep-positions)]]
      [:td
       [:div.field
        [:div.control
         [:label.b-checkbox.checkbox
          [:input
           {:id        :sleep-position-side
            :name      :sleep-position-side
            :type      :checkbox
            :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/sleep-positions :value])
                                  :sleep-position/side)
            :on-change (fn [e]
                         (let [sleep-positions (get-in @state [:patient :patient/last-consult :consult/sleep-positions :value])
                               old-value       (contains? sleep-positions :sleep-position/side)
                               new-value       (-> e .-target .-checked)
                               changed?        (or (get-in @state
                                                           [:patient :patient/last-consult :consult/sleep-positions :dirty?])
                                                   (not= new-value old-value))]
                           (if (and changed? new-value)
                             (swap! state update-in
                                    [:patient :patient/last-consult :consult/sleep-positions :value]
                                    conj :sleep-position/side)
                             (swap! state update-in
                                    [:patient :patient/last-consult :consult/sleep-positions :value]
                                    disj :sleep-position/side))
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/sleep-positions :dirty?]
                                  changed?)))
            :on-focus  (fn [_] (swap! state assoc-in
                                      [:patient :patient/last-consult :consult/sleep-positions :touched?]
                                      true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.sleep-position/side)]]]
        [:div.control
         [:label.b-checkbox.checkbox
          [:input
           {:id        :sleep-position-back
            :name      :sleep-position-back
            :type      :checkbox
            :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/sleep-positions :value])
                                  :sleep-position/back)
            :on-change (fn [e]
                         (let [sleep-positions (get-in @state [:patient :patient/last-consult :consult/sleep-positions :value])
                               old-value       (contains? sleep-positions :sleep-position/back)
                               new-value       (-> e .-target .-checked)
                               changed?        (or (get-in @state [:patient :patient/last-consult :consult/sleep-positions :dirty?])
                                                   (not= new-value old-value))]
                           (if (and changed? new-value)
                             (swap! state update-in
                                    [:patient :patient/last-consult :consult/sleep-positions :value]
                                    conj :sleep-position/back)
                             (swap! state update-in
                                    [:patient :patient/last-consult :consult/sleep-positions :value]
                                    disj :sleep-position/back))
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/sleep-positions :dirty?]
                                  changed?)))
            :on-focus  (fn [_] (swap! state assoc-in
                                      [:patient :patient/last-consult :consult/sleep-positions :touched?]
                                      true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.sleep-position/back)]]]
        [:div.control
         [:label.b-checkbox.checkbox
          [:input
           {:id        :sleep-position-stomach
            :name      :sleep-position-stomach
            :type      :checkbox
            :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/sleep-positions :value])
                                  :sleep-position/stomach)
            :on-change (fn [e]
                         (let [sleep-positions (get-in @state [:patient :patient/last-consult :consult/sleep-positions :value])
                               old-value       (contains? sleep-positions :sleep-position/stomach)
                               new-value       (-> e .-target .-checked)
                               changed?        (or (get-in @state [:patient :patient/last-consult :consult/sleep-positions :dirty?])
                                                   (not= new-value old-value))]
                           (if (and changed? new-value)
                             (swap! state update-in
                                    [:patient :patient/last-consult :consult/sleep-positions :value]
                                    conj :sleep-position/stomach)
                             (swap! state update-in
                                    [:patient :patient/last-consult :consult/sleep-positions :value]
                                    disj :sleep-position/stomach))
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/sleep-positions :dirty?]
                                  changed?)))
            :on-focus  (fn [_] (swap! state assoc-in
                                      [:patient :patient/last-consult :consult/sleep-positions :touched?]
                                      true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.sleep-position/stomach)]]]
        [:div.control
         [:label.b-checkbox.checkbox
          [:input
           {:id        :sleep-position-upright
            :name      :sleep-position-upright
            :type      :checkbox
            :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/sleep-positions :value])
                                  :sleep-position/upright)
            :on-change (fn [e]
                         (let [sleep-positions (get-in @state [:patient :patient/last-consult :consult/sleep-positions :value])
                               old-value       (contains? sleep-positions :sleep-position/upright)
                               new-value       (-> e .-target .-checked)
                               changed?        (or (get-in @state [:patient :patient/last-consult :consult/sleep-positions :dirty?])
                                                   (not= new-value old-value))]
                           (if (and changed? new-value)
                             (swap! state update-in
                                    [:patient :patient/last-consult :consult/sleep-positions :value]
                                    conj :sleep-position/upright)
                             (swap! state update-in
                                    [:patient :patient/last-consult :consult/sleep-positions :value]
                                    disj :sleep-position/upright))
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/sleep-positions :dirty?]
                                  changed?)))
            :on-focus  (fn [_] (swap! state assoc-in
                                      [:patient :patient/last-consult :consult/sleep-positions :touched?]
                                      true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.sleep-position/upright)]]]]]
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-left
            {:data-tooltip (tr :ui.survey.pacemaker/question)}
            (tr :ui.label/pacemaker?)]]
      [:td
       [:div.field.is-grouped-multiline.is-grouped
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "pacemaker"
                         :checked   (true? (get-in @state [:patient :patient/last-consult :consult/pacemaker? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/pacemaker? :value])
                                            new-value (when (-> e .-target .-checked) true)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/pacemaker? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/pacemaker? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/pacemaker? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/pacemaker? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/yes)]]]
        [:div.control
         [:label.b-radio.radio
          [:input.input {:type      :radio
                         :name      "pacemaker"
                         :checked   (false? (get-in @state [:patient :patient/last-consult :consult/pacemaker? :value]))
                         :on-change (fn [e]
                                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/pacemaker? :value])
                                            new-value (when (-> e .-target .-checked) false)
                                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/pacemaker? :dirty?])
                                                          (not= new-value old-value))]
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/pacemaker? :value]
                                               new-value)
                                        (swap! state assoc-in
                                               [:patient :patient/last-consult :consult/pacemaker? :dirty?]
                                               changed?)))
                         :on-focus  (fn [_] (swap! state assoc-in
                                                   [:patient :patient/last-consult :consult/pacemaker? :touched?]
                                                   true))}]
          [:span.check.is-info]
          [:span.control-label (tr :ui.label/no)]]]]]]
     [:tr                           ; fourth row
      [:th [:span.has-tooltip-arrow.has-tooltip-multiline.has-tooltip-right
            {:data-tooltip (tr :ui.survey.issues/question)}
            (tr :ui.label/issues)]]
      [:td {:col-span 5}
       (if-not (get-in @state [:patient :patient/last-consult :consult/mask-was-comfortable? :value])
         [:div.field
          [:div.control
           [:label.b-checkbox.checkbox
            [:input
             {:id        :issue-claustrophobic
              :name      :issue-claustrophobic
              :type      :checkbox
              :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                    :issue/claustrophobic)
              :on-change (fn [e]
                           (let [issues    (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                 old-value (contains? issues :issue/claustrophobic)
                                 new-value (-> e .-target .-checked)
                                 changed?  (or (get-in @state [:patient :patient/last-consult :consult/issues :dirty?])
                                               (not= new-value old-value))]
                             (if (and changed? new-value)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      conj :issue/claustrophobic)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      disj :issue/claustrophobic))
                             (swap! state assoc-in [:patient :patient/last-consult :consult/issues :dirty?] changed?)))
              :on-focus  (fn [_] (swap! state assoc-in [:patient :patient/last-consult :consult/issues :touched?] true))}]
            [:span.check.is-info]
            [:span.control-label (tr :ui.issue/claustrophobic)]]]
          [:div.control
           [:label.b-checkbox.checkbox
            [:input
             {:id        :issue-breathing
              :name      :issue-breathing
              :type      :checkbox
              :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                    :issue/breathing)
              :on-change (fn [e]
                           (let [issues    (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                 old-value (contains? issues :issue/breathing)
                                 new-value (-> e .-target .-checked)
                                 changed?  (or (get-in @state [:patient :patient/last-consult :consult/issues :dirty?])
                                               (not= new-value old-value))]
                             (if (and changed? new-value)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      conj :issue/breathing)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      disj :issue/breathing))
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/issues :dirty?]
                                    changed?)))
              :on-focus  (fn [_] (swap! state assoc-in
                                        [:patient :patient/last-consult :consult/issues :touched?]
                                        true))}]
            [:span.check.is-info]
            [:span.control-label (tr :ui.issue/breathing)]]]
          [:div.control
           [:label.b-checkbox.checkbox
            [:input
             {:id        :issue-eye
              :name      :issue-eye
              :type      :checkbox
              :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                    :issue/eye)
              :on-change (fn [e]
                           (let [issues    (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                 old-value (contains? issues :issue/eye)
                                 new-value (-> e .-target .-checked)
                                 changed?  (or (get-in @state [:patient :patient/last-consult :consult/issues :dirty?])
                                               (not= new-value old-value))]
                             (if (and changed? new-value)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      conj :issue/eye)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      disj :issue/eye))
                             (swap! state assoc-in [:patient :patient/last-consult :consult/issues :dirty?] changed?)))
              :on-focus  (fn [_] (swap! state assoc-in
                                        [:patient :patient/last-consult :consult/issues :touched?]
                                        true))}]
            [:span.check.is-info]
            [:span.control-label (tr :ui.issue/eye)]]]
          [:div.control
           [:label.b-checkbox.checkbox
            [:input
             {:id        :issue-nose
              :name      :issue-nose
              :type      :checkbox
              :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                    :issue/nose)
              :on-change (fn [e]
                           (let [issues    (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                 old-value (contains? issues :issue/nose)
                                 new-value (-> e .-target .-checked)
                                 changed?  (or (get-in @state [:patient :patient/last-consult :consult/issues :dirty?])
                                               (not= new-value old-value))]
                             (if (and changed? new-value)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      conj :issue/nose)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      disj :issue/nose))
                             (swap! state assoc-in [:patient :patient/last-consult :consult/issues :dirty?] changed?)))
              :on-focus  (fn [_] (swap! state assoc-in
                                        [:patient :patient/last-consult :consult/issues :touched?]
                                        true))}]
            [:span.check.is-info]
            [:span.control-label (tr :ui.issue/nose)]]]
          [:div.control
           [:label.b-checkbox.checkbox
            [:input
             {:id        :issue-forehead
              :name      :issue-forehead
              :type      :checkbox
              :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                    :issue/forehead)
              :on-change (fn [e]
                           (let [issues    (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                 old-value (contains? issues :issue/forehead)
                                 new-value (-> e .-target .-checked)
                                 changed?  (or (get-in @state [:patient :patient/last-consult :consult/issues :dirty?])
                                               (not= new-value old-value))]
                             (if (and changed? new-value)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      conj :issue/forehead)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      disj :issue/forehead))
                             (swap! state assoc-in [:patient :patient/last-consult :consult/issues :dirty?] changed?)))
              :on-focus  (fn [_] (swap! state assoc-in
                                        [:patient :patient/last-consult :consult/issues :touched?]
                                        true))}]
            [:span.check.is-info]
            [:span.control-label (tr :ui.issue/forehead)]]]
          [:div.control
           [:label.b-checkbox.checkbox
            [:input
             {:id        :issue-face
              :name      :issue-face
              :type      :checkbox
              :checked   (contains? (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                    :issue/face)
              :on-change (fn [e]
                           (let [issues    (get-in @state [:patient :patient/last-consult :consult/issues :value])
                                 old-value (contains? issues :issue/face)
                                 new-value (-> e .-target .-checked)
                                 changed?  (or (get-in @state [:patient :patient/last-consult :consult/issues :dirty?])
                                               (not= new-value old-value))]
                             (if (and changed? new-value)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      conj :issue/face)
                               (swap! state update-in
                                      [:patient :patient/last-consult :consult/issues :value]
                                      disj :issue/face))
                             (swap! state assoc-in [:patient :patient/last-consult :consult/issues :dirty?] changed?)))
              :on-focus  (fn [_] (swap! state assoc-in
                                        [:patient :patient/last-consult :consult/issues :touched?]
                                        true))}]
            [:span.check.is-info]
            [:span.control-label (tr :ui.issue/face)]]]]
         [:span (tr :ui.label/na)])]]]]])
